export function sendMetrik(event, goal) {
    if (window.ym) {
        window.ym(98113362, event, goal);
    }
}